/*
 * @Descripttion: 人群选择通用组件--目前只提供给画布用
 * @Author: xutingting
 * @LastEditors: yang chenglin
 */
import React, { useEffect, useState } from 'react';
import {
  Form,
  Input,
  Button,
  Balloon,
  Tab,
  Table,
  Select,
  NumberPicker,
} from '@alifd/next';
import moment from 'moment';
import LzDialog from '@/components/common/LzDialog';
import LzPagination from '@/components/common/LzPagination';
import LzMsg from '@/components/common/LzMsg';
import { CanvasService, Servlets } from '@/service';
import styles from './index.module.scss';

// 查询参数：人群类型下拉列表
const corwdType = [
  { value: 1, label: '官方标签筛选' },
  // { value: 2, label: '手机号上传' },
  { value: 3, label: '官方推荐人群' },
  // { value: 4, label: '云鹿标签筛选' },
  { value: 5, label: '官方标签筛选（新）' },
  { value: 6, label: '云鹿转官方人群' },
  // { value: 7, label: '订单号生成云鹿人群' },
  { value: 8, label: '订单号生成官方人群' },
  { value: 9, label: '手机号生成官方人群' },
  { value: 10, label: '抖店openid生成官方人群' }
];

const SelectCrowd = (props) => {
  /**
   * @param showDialog 是否显示弹窗 BOOLEAN
   * @param closeDialog 关闭弹窗方法 FUNCTION
   * @param selectCrowd 传所选人群数据给父组件
   * @param showPackageListRange 显示人群包数据范围：SHOWALL：显示全部  ONLYNOUSE ：只展示未使用状态人群包
   * @param clearParam 父组件每次关闭或打开改变此布尔值，useEffect监听到变化，清空form参数
   * @param showTips 是否展示提示
   * @param tipsContent 提示具体内种
   */
  const {
    showDialog,
    closeDialog,
    selectCrowd,
    showTips = false,
    tipsContent =''
  } = props;
  const [loading, setLoading] = useState(false);
  const [crowdStrategyList, setCrowdStrategyList] = useState([]); // 人群策略数据源
  const [formSelectStrategy, setFormSelectStrategy] = useState({
    // 人群策略搜索框存储数据的form表单数据
    crowdName: '', // 人群名称
    type: '', // 人群类型
    minCount: null, // 人群数量范围起
    maxCount: null, // 人群数量范围止
  });
  const [formSelectStrategy1, setFormSelectStrategy1] = useState({
    // 人群策略搜索框提交的form表单数据
    crowdName: '', // 人群名称
    type: '', // 人群类型
    minCount: null, // 人群数量范围起
    maxCount: null, // 人群数量范围止
  });

  const [pageInfoStrategy, setPageInfoStrategy] = useState({
    // 人群策略分页数据
    pageNo: 1,
    pageSize: 10,
    total: 0,
  });
  const strategyOption = [
    // 人群策略-人群类型下拉框
    { label: '全部', value: '' },
    { label: '标签筛选', value: 11 },
    { label: '智能筛选', value: 12 },
    { label: '标签运算', value: 13 },
  ];
  const { Tooltip } = Balloon;

  /**
   * 人群策略翻页方法
   */
  const handlePageSizeChangeStrategy = async (pages = {}) => {
    try {
      setPageInfoStrategy({
        ...pageInfoStrategy,
        ...pages,
      });
      searchCrowdstrategysList(
        {
          pageSize: pages.pageSize,
          pageNo: pages.pageNo,
          ...formSelectStrategy1,
        },
        true
      );

      console.log(pageInfoStrategy, pages.pageNo);
    } catch (e) {
      LzMsg.error(e.message);
    }
  };

  /**
   * 初始化
   */
  useEffect(() => {
    searchCrowdstrategysList(); // 人群策略列表
  }, []);

  useEffect(() => {
    setFormSelectStrategy({
      // 搜索框提交的form表单数据
      crowdName: '', // 人群名称
      type: '', // 人群类型
      minCount: null, // 人群数量范围起
      maxCount: null, // 人群数量范围止
    });
  }, [props.clearParam]);
  /**
   * 初始化人群策略列表
   */
  const searchCrowdstrategysList = (v, isPageChange) => {
    if (
      formSelectStrategy.minCount &&
      formSelectStrategy.maxCount &&
      formSelectStrategy.maxCount <= formSelectStrategy.minCount
    ) {
      LzMsg.error('人群数量最大值不应小于人群数量最小值');
      return false;
    }
    setLoading(true);
    const typeValue = v?.type || formSelectStrategy.type || '1,3,5,6,8,9,10';
    const params = {
      crowdStatus: 1, // 0不可用，1可用，2生成中，3已过期
      pageNo: pageInfoStrategy.pageNo,
      pageSize: pageInfoStrategy.pageSize,
      ...formSelectStrategy,
      ...v,
      type: typeValue, // 人群类型
    };
    // CanvasService.crowdstrategysList(isPageChange === true ? v : params)
    //   .then((res) => {
    //     setCrowdStrategyList(res.data);
    //     if (res.page) {
    //       for (const key in res.page) {
    //         if (key == 'pageNo') {
    //           res.page.pageNo = res.page[key];
    //         }
    //       }
    //       setPageInfoStrategy(res.page);
    //     } else {
    //       setPageInfoStrategy(pageInfoStrategy);
    //     }
    //     setLoading(false);
    //   })
    //   .catch((e) => {
    //     LzMsg.error('请求失败，请稍后重试');
    //     setLoading(false);
    //   });

      Servlets('getDYCrowdList', params).then((res) => {
        if (res.success) {
          setCrowdStrategyList(res.data);
          setLoading(false);
          setPageInfoStrategy({
            ...pageInfoStrategy,
            pageNo: res.page.pageNo,
            pageSize: res.page.pageSize,
            total: res.page.total,
          });
        } else {
          setLoading(false);
          LzMsg.error(res.resp_msg);
        }
      });
  };


  /**
   * 选择一条人群策略/人群包
   * type:1 人群策略 type:2 人群包 type:1 重点人群
   */
  const selectCrowdItem = (item, type, index) => {
    selectCrowd({ ...item, crowdType: type }, type, index);
  };

  /**
   * 关闭弹窗
   */
  const handleCancel = () => {
    closeDialog();
    setFormSelectStrategy({
      // 搜索框提交的form表单数据
      crowdName: '', // 人群名称
      type: '', // 人群类型
      minCount: null, // 人群数量范围起
      maxCount: null, // 人群数量范围止
    });
  };

  // 人群策略的重置
  const strategyRest = () => {
    setFormSelectStrategy1({
        crowdName: '',
        type: '',
        minCount: null,
        maxCount: null,
      });
      setFormSelectStrategy({
        crowdName: '',
        type: '',
        minCount: null,
        maxCount: null,
      });
      searchCrowdstrategysList({
        pageNo: 1,
        crowdName: '',
        minCount: '',
        maxCount: '',
        type: '1,3,5,6,8,9,10',
      });
  };

  /**
   * 重置
   */
  const handleReset = () => {
      strategyRest();
  };

  /**
   * 使用标签列
   */
  const labelsDescriptionRender = (value, index, item) => {
    return (<>
      {
        item.useLabelDescription
          ?
          (
            <Balloon
              align="t"
              closable={false}
              style={{ color: '#9ca7b6', paddingLeft: '5px' }}
              align="rb"
              trigger={
                <div>
                  <div style={{
                    width: '100px',
                    overflow: 'hidden',
                    whiteSpace: 'nowrap',
                    textOverflow: 'ellipsis',
                  }}
                  >
                    {item.useLabelDescription}
                  </div>
                </div>
              }
            >
              <div style={{ padding: '0px 0px 10px 10px', textAlign: 'justify', color: '#9ca7b6' }}>
                {item.useLabelDescription}
              </div>
            </Balloon>
          )
          :
          '/'
      }
    </>);
  };

  return (
    <div>
      <LzDialog
        title="选择人群"
        footer={false}
        isFullScreen
        visible={showDialog}
        onClose={handleCancel}
        shouldUpdatePosition
        style={{ width: 1060 }}
      >
        <div className="select-crowd">
          {
            showTips && <div className={styles.tipsText}>{tipsContent}</div>
          }
          <Form inline style={{ marginTop: '20px' }}>
            <Form.Item label="人群名称：">
              <Input
                trim
                style={{ width: '200px' }}
                className="formItemWidth"
                name="crowdName"
                placeholder="请输入人群名称"
                size="small"
                value={formSelectStrategy.crowdName}
                onChange={(v) =>
                  setFormSelectStrategy({
                    ...formSelectStrategy,
                    crowdName: v,
                  })
                }
              />
            </Form.Item>
            <Form.Item label="人群类型：">
              <Select
                style={{ width: '200px' }}
                followTrigger
                dataSource={corwdType}
                value={formSelectStrategy.type}
                onChange={(v) =>
                  setFormSelectStrategy({
                    ...formSelectStrategy,
                    type: v,
                  })
                }
              />
            </Form.Item>
            <Form.Item label="人群数量：">
              <NumberPicker
                min={0}
                hasTrigger={false}
                style={{ width: '50px' }}
                className={`formItemWidth ${styles.mr10}`}
                name="minCount"
                size="small"
                value={formSelectStrategy.minCount}
                onChange={(v) =>
                  setFormSelectStrategy({
                    ...formSelectStrategy,
                    minCount: v,
                  })
                }
              />
              <span className={`${styles.mr10}`}>-</span>
              <NumberPicker
                min={0}
                hasTrigger={false}
                style={{ width: '50px' }}
                className="formItemWidth"
                name="maxCount"
                size="small"
                value={formSelectStrategy.maxCount}
                onChange={(v) =>
                  setFormSelectStrategy({
                    ...formSelectStrategy,
                    maxCount: v,
                  })
                }
              />
            </Form.Item>
            <Form.Item>
              <Button
                type="primary"
                className={`${styles.mr10} ${styles.w88}`}
                onClick={() => {
                  setFormSelectStrategy1(formSelectStrategy);
                  searchCrowdstrategysList({ pageNo: 1 });
                }}
              >
                查询
              </Button>
              <Button
                type="normal"
                className={styles.w88}
                onClick={() => {
                  handleReset(1);
                }}
              >
                重置
              </Button>
            </Form.Item>
          </Form>
          <Table
            loading={loading}
            dataSource={crowdStrategyList}
            fixedHeader
            maxBodyHeight={
              document.documentElement.clientHeight * 0.7 - 190
            }
            className={styles['crowd-table']}
          >
            <Table.Column
              title="人群名称"
              align="left"
              dataIndex="name"
              width="194"
            />
            <Table.Column
              title="人群描述"
              align="left"
              dataIndex="description"
              width="194"
            />
            <Table.Column
              title="人群类型"
              align="left"
              cell={(value, index, record) => (
                <span>{corwdType.find((item) => item.value === record.type)?.label}</span>
              )}
              width="194"
            />
            <Table.Column
              title="使用标签"
              align="left"
              cell={labelsDescriptionRender}
              width="194"
            />
            <Table.Column
              title="人群总数量"
              align="left"
              cell={(value, index, record) => (
                <span>{record.size.toLocaleString()}</span>
              )}
              width="194"
            />
            <Table.Column
              title="创建时间"
              align="left"
              cell={(value, index, record) => (
                <span>{moment(record.createTime).format('YYYY-MM-DD HH:mm:ss')}</span>
              )}
              width="194"
            />
            <Table.Column
              title="状态"
              align="left"
              cell={(value, index, record) => (
                <span>{record.crowdStatus === 1 ? '可用' : '不可用'}</span>
              )}
              width="194"
            />
            <Table.Column
              title="已使用次数"
              align="left"
              cell={(value, index, record) => (
                <span>{record.useCount.toLocaleString()}</span>
              )}
              width="194"
            />
            <Table.Column
              align="center"
              title="操作"
              width={121}
              cell={(value, index, item) => {
                return (
                  <Button
                    type="primary"
                    text
                    onClick={() => {
                      selectCrowdItem(item, 2);
                    }}
                  >
                    选择
                  </Button>
                );
              }}
            />
          </Table>
          <LzPagination
            pageInfo={pageInfoStrategy}
            onChange={handlePageSizeChangeStrategy}
          />
        </div>
      </LzDialog>
    </div>
  );
};

export default SelectCrowd;
